import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-center mb-x6" }
const _hoisted_2 = {
  type: "submit",
  class: "hidden"
}
const _hoisted_3 = { class: "o-scrollbar-y sm:px-x3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "block font-bold"
}
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "block" }
const _hoisted_8 = {
  key: 1,
  class: "table mt-x1"
}
const _hoisted_9 = { class: "capitalize table-cell pr-x1" }
const _hoisted_10 = {
  key: 0,
  class: "bg-brandy px-x1 py-4 o-text-caption"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "w-full flex justify-center"
}

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import InputText from '@/shared/form/InputText.vue';
import { useCheckout } from '@/storecontext/checkout/useCheckout';
import { useForm } from 'vee-validate';
import { computed, ref, onMounted } from 'vue';
import { ParcelShopModel } from '@/storecontext/shared/api/server-apis';
import CheckoutPickAndPackParcelShopSkeleton from '@/storecontext/checkout/ui/deliverables/pick-and-pack/CheckoutPickAndPackParcelShopSkeleton.vue';
import siteContextService from '@/storecontext/shared/site-context.service';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickAndPackParcelShopDialog',
  props: {
    selectedParcelShop: null,
    deliverableId: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
    selectedParcelShop?: ParcelShopModel | null;
    deliverableId?: number;
}





const globalLabels = useGlobalLabels(GlobalLabels.search);
const labels = useBlockLabels();

const close = (): void => {
    emit('close');
};

const { getParcelShopsForZipCode, invoiceAddress, setPickAndPackToParcelShopDelivery, getNearestParcelShopsForDelivery } = useCheckout();

const postalCodeValidationRegEx = computed<string>(() => siteContextService.country.postalCodeRegex);
const { handleSubmit } = useForm({
    initialValues: { postalCode: invoiceAddress.value?.address?.postalCode ?? '' },
    validationSchema: {
        postalCode: {
            postalCode: postalCodeValidationRegEx.value,
        },
    },
});

const loadingParcelShops = ref<boolean>(false);
const optimisticallySelectedParcelShop = ref<ParcelShopModel | null>(null);
const parcelShops = ref<ParcelShopModel[]>([]);
const showLoadAllButton = ref<boolean>(true);

onMounted(() => {
    fetchAndSetNearestParcelShops(10);
});

const fetchAndSetNearestParcelShops = async(amount: number) => {
    if (props.deliverableId) {
        loadingParcelShops.value = true;
        const response = await getNearestParcelShopsForDelivery(props.deliverableId, amount);
        parcelShops.value = response;
        loadingParcelShops.value = false;
    }
};

const fetchAllNearestParcelShops = async() => {
    fetchAndSetNearestParcelShops(50);
    showLoadAllButton.value = false;
};

const isSelectedParcelShop = (parcelShop: ParcelShopModel) => {
    return optimisticallySelectedParcelShop?.value?.idNumber === parcelShop.idNumber || (!optimisticallySelectedParcelShop.value && props.selectedParcelShop?.idNumber === parcelShop.idNumber);
};

const input = async(event: any) => {
    if (event.target.value.match(postalCodeValidationRegEx.value) === null) {
        return;
    }
    const response = await getParcelShopsForZipCode(event.target.value);
    showLoadAllButton.value = false;
    parcelShops.value = response;
};

const submit = handleSubmit(async(form) => {
    if (loadingParcelShops.value) {
        return;
    }

    loadingParcelShops.value = true;

    try {
        const response = await getParcelShopsForZipCode(form.postalCode);
        parcelShops.value = response;
    } catch (err) {
        console.error(err);
    } finally {
        loadingParcelShops.value = false;
        showLoadAllButton.value = false;
    }
});

const selectParcelShop = async(parcelShop: ParcelShopModel) => {
    optimisticallySelectedParcelShop.value = parcelShop;
    try {
        await setPickAndPackToParcelShopDelivery(parcelShop);
    } catch (err) {
        console.error(err);
    } finally {
        optimisticallySelectedParcelShop.value = null;
        close();
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDialog, {
    "is-open": true,
    class: "fixed inset-0 p-x3 mx-auto z-1 bg-white max-w-850 pt-60 flex flex-col sm:relative sm:inset-auto sm:h-auto sm:w-screen-60 md:w-screen-40 sm:max-h-screen-80",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(labels).pickAndPackParcelShopDialogTitle), 1),
      _createElementVNode("form", {
        class: "sm:px-x3",
        action: ".",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)), ["prevent"]))
      }, [
        _createVNode(InputText, {
          name: "postalCode",
          type: "search",
          label: _unref(labels).pickAndPackPostalCodeLabel,
          onInput: input
        }, null, 8, ["label"]),
        _createElementVNode("button", _hoisted_2, _toDisplayString(_unref(globalLabels).searchSubmit), 1)
      ], 32),
      _createElementVNode("div", _hoisted_3, [
        (!loadingParcelShops.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parcelShops.value, (parcelShop) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: parcelShop.idNumber,
                  class: "flex justify-between mb-x3"
                }, [
                  _createElementVNode("div", null, [
                    (parcelShop?.companyName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(parcelShop?.companyName), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_6, [
                      _createTextVNode(_toDisplayString(parcelShop?.street), 1),
                      (parcelShop?.street2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(parcelShop?.postalCode) + " " + _toDisplayString(parcelShop?.city), 1),
                    (parcelShop?.openingHours)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parcelShop?.openingHours, (day) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: day.dayOfWeek,
                              class: "table-row"
                            }, [
                              _createElementVNode("span", _hoisted_9, _toDisplayString(day.dayOfWeek) + ":", 1),
                              _createTextVNode(" " + _toDisplayString(day.openFrom) + " - " + _toDisplayString(day.openTo), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    (isSelectedParcelShop(parcelShop))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(labels).pickAndPackParcelShopDialogSelectedLabel), 1))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "c-magic-line c-magic-line--underline text-dusty-grey",
                          onClick: ($event: any) => (selectParcelShop(parcelShop))
                        }, _toDisplayString(_unref(labels).pickAndPackParcelShopDialogChangeButton), 9, _hoisted_11))
                  ])
                ]))
              }), 128)),
              (showLoadAllButton.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "c-button c-button--outline mt-x2",
                      onClick: fetchAllNearestParcelShops
                    }, _toDisplayString(_unref(labels).pickAndPackParcelShopShowAllButton), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock(CheckoutPickAndPackParcelShopSkeleton, { key: 1 }))
      ])
    ]),
    _: 1
  }))
}
}

})